import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { emitTransformCode } from 'storybook/internal/preview-api';
import { CalendarFold } from 'lucide-angular';

@Injectable({
  providedIn: 'root'
})

export class TeaserTrailerService {

  constructor(private http: HttpClient) {}

  getTeaserOrTrailers(id: number,type:string): Observable<any> {
    
    return this.http.get<any>(`${environment.backendUrl}/api/${type}/${id}/videos`);

  }
}


